import { UnreachableError } from '@/utils/errors';

import {
  getTermVizFromEntity,
  GetTermVizFromEntityInput,
} from './getTermVizFromEntity';
import { CrtTermDiagram_EntityFragment } from './graphql/CrtTermDiagram.generated';

export interface GetCrtTermVizFromEntityInput {
  entity: CrtTermDiagram_EntityFragment;
  firstGrantorDeathId: string;
  survivingSpouse?: {
    id: string;
    displayName: string;
  };
}

export function getCrtTermVizFromEntity({
  entity,
  firstGrantorDeathId,
  survivingSpouse,
}: GetCrtTermVizFromEntityInput) {
  if (entity.subtype.__typename !== 'CRTTrust') {
    throw new UnreachableError({
      case: entity.subtype.__typename as never,
      message: 'Entity is not a CRTTrust',
    });
  }

  const grantors: GetTermVizFromEntityInput['grantors'] = [];
  entity.subtype.grantors?.forEach((g) => {
    if (!g.individual) {
      return;
    }

    grantors.push({
      id: g.id,
      individual: {
        id: g.individual.id,
        displayName: g.individual.displayName,
      },
    });
  });

  const lifetimeBeneficiaries: GetTermVizFromEntityInput['currentTermBeneficiaries'] =
    [];
  entity.subtype.lifetimeBeneficiaries?.forEach((lb) => {
    lifetimeBeneficiaries.push({
      id: lb.id,
      individual: lb.individual,
      organization: lb.organization,
      entity: lb.entity,
    });
  });

  const termBeneficiaries: GetTermVizFromEntityInput['termEndBeneficiaries'] =
    [];
  entity.subtype.remainderBeneficiaries?.forEach((rb) => {
    termBeneficiaries.push({
      id: rb.id,
      individual: rb.individual,
      organization: rb.organization,
      entity: rb.entity,
    });
  });

  return getTermVizFromEntity({
    entity,
    grantors,
    currentTermBeneficiaries: lifetimeBeneficiaries,
    termEndBeneficiaries: termBeneficiaries,
    firstGrantorDeathId,
    survivingSpouse,
  });
}
